export default __webpack_public_path__ + "static/media/appstore.dd1636ea.png";